<dx-form labelMode="floating" labelLocation="top" [colCount]="4" [formData]="formData" style="padding: 0 !important;">


    <dxi-item dataField="selectedMonth" editorType="dxLookup" [colSpan]="4"
    [editorOptions]="{
      dataSource: MonthsListArray, 
      displayExpr: 'nameAr', 
      valueExpr: 'id', 
      searchEnabled: true, 
      showClearButton: true, 
      onValueChanged: onMonthSelectionChanged
    }">
        <dxo-label template="{{'approval.month' | translate}}"></dxo-label>
        <dxi-validation-rule type="required"
        message="{{'errors.namerequired' | translate}}"></dxi-validation-rule>
      </dxi-item>

  
    <!-- Year Selection using dxLookup -->
    <dxi-item dataField="selectedYear" editorType="dxLookup" [colSpan]="4"
    [editorOptions]="{
      dataSource: years,
      displayExpr: 'nameAr',
      valueExpr: 'id',
      searchEnabled: true,
      showClearButton: true,
      onValueChanged: onyearselectionchanged
    }">
  <dxo-label template="{{'approval.year' | translate}}"></dxo-label>
  <dxi-validation-rule type="required"
  message="{{'errors.namerequired' | translate}}"></dxi-validation-rule>
  </dxi-item>

  <dx-form>
  